import {getAPIbaseURL} from "@/api/config/init";

const prex = `${getAPIbaseURL()}/relatorio/ranfs/`;

export function setRelRanfs(ran_hash) {
    return `${prex}${ran_hash}`;
}